import React, { useState, useContext, useEffect } from "react";
import moment from "moment";
import DataTable, { createTheme } from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { statusData } from "variables/lists/meters";
import useDashboardTable from "./useDashboardTable.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import ReactLoading from "react-loading";
import { monthnameData } from "variables/lists/meters";
import { metertext } from "variables/meters";
import "./table.css";

const LoadingDiv = styled.div`
height: 20vh;
width: 20vw;
display: flex;
flex-wrap: nowrap;
align-content: center;
justify-content: center;
padding-top: 10vh;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

createTheme('solarized', {
  text: {
    primary: '#000000',
    secondary: '#000000',
  },
  background: {
    default: '#e6e5eb',
  },
  context: {
    background: '#e6e5eb',
    text: '#000000',
  },
  divider: {
    default: '#FFFFFF',
  },
  action: {
    button: 'rgba(0,0,0,.54)',
    hover: 'rgba(0,0,0,.08)',
    disabled: 'rgba(0,0,0,.12)',
  },
}, 'dark');


const useStyles = makeStyles(styles);

const useStyles2 = makeStyles((theme) => ({
  table: {
    "& .bINImG": {
      display: "block",
    },
  },
}));

const RTDashboard = () => {
  const { gridState, refetch, setSelectedPdls, year, columns, setColumns } = useDashboardTable();
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const classes = useStyles();


  const conditionalRowStyles = [
    {
      when: row => row.billcanceled == 1,
      style: {
        backgroundColor: '#F44336',
        color: 'white',
      },
    },
  ];


  const customSort = (rows, selector, direction) => {
    return rows.sort((a, b) => {
      console.log(selector(a));
      console.log(selector(b));
      const aField = selector(a) || 0;
      const bField = selector(b) || 0;

      let comparison = 0;

      if (aField > bField) {
        comparison = 1;
      } else if (aField < bField) {
        comparison = -1;
      }

      return direction === 'desc' ? comparison * -1 : comparison;
    });
  };


  useEffect(() => {
    let columnsByPDL = [
      {
        name: "PDL",
        selector: (row) => row.pdl,
        sortable: true,
         width: "10rem",
        cell: (row) => row.pdl
      },
      {
        name: metertext.status,
        selector: (row) => row.status,
        sortable: true,
        width: "8rem",
        cell: (row) => row.status ?
          <div style={{ color: statusData.find((x) => x.id == row.status).color, fontWeight: "bold" }}>
            {statusData.find((x) => x.id == row.status).name}
          </div> : <></>
      },
      // {
      //   name: "",
      //   sortable: false,
      //   width: "10rem",
      //   omit: (currentusertype!=1 && !UserService.getEmail().endsWith('@besancon.fr')),
      //   cell: (row) => (
      //     <>
      //       <div className="actions-right">
      //         {
      //           bills_admin &&
      //             <Tooltip title="Etat de paiement">
      //               <Button
      //                 onClick={editEtatPaiement(row)}
      //                 color={"info"}
      //                 className={classes.actionButton}
      //               >
      //                 <GetAppIcon fontSize="large" />
      //               </Button>
      //             </Tooltip>
      //         }
      //       </div>
      //     </>
      //   ),
      // },
    ];
    if (year) {
      let date = moment(year + '-01-01');
      for (let i = 0; i < 12; i++) {

        let month = monthnameData.find((obj) => obj.id === date.format("MMMM")).name;
        let year = date.format("YYYY");
        let monthkey = date.format("YYYY-MM");
        let daycount = date.daysInMonth();

        let header = {
          name: month + " " + year,
          selector: (row) => row[monthkey],
          sortable: true,
          maxWidth: "8rem",
          cell: (row) => row[monthkey] ? Math.floor((row[monthkey] / daycount) * 100) + "%" : "0%",
          conditionalCellStyles: [
            {
              when: row => !row[monthkey],
              style: {
                backgroundColor: '#E6E5EB',
                color: 'rgba(0, 0, 0, 0.87)',
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
            {
              when: row => row[monthkey] && row[monthkey] / daycount <= 0.5,
              style: {
                backgroundColor: '#6B3CC8',
                color: 'white',
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
            {
              when: row => row[monthkey] && row[monthkey] / daycount > 0.5 && row[monthkey] / daycount <= 0.95,
              style: {
                backgroundColor: '#3E8FC6',
                color: 'white',
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
            {
              when: row => row[monthkey] && row[monthkey] / daycount > 0.95 && row[monthkey] / daycount < 1.1,
              style: {
                backgroundColor: '#91C73C',
                color: 'white',
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
            {
              when: row => row[monthkey] && row[monthkey] / daycount >= 1.1 && row[monthkey] / daycount < 1.5,
              style: {
                backgroundColor: '#FF763A',
                color: 'white',
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
            {
              when: row => row[monthkey] && row[monthkey] / daycount >= 1.5,
              style: {
                backgroundColor: '#C53F3F',
                color: 'white',
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
          ],
        }
        columnsByPDL.push(header);
        date = date.add(1, 'month');
      }
    }

    setColumns(columnsByPDL);
  }, [year]);

  const handleSelectedRowsChange = (selection) => {
    setSelectedPdls(selection.selectedRows);
  };

  const classes2 = useStyles2();
  return (
    <>


      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucune donnée à afficher</NoData>}
        // noHeader={true}
        title=""
        dense
        sortFunction={customSort}
        columns={columns}
        persistTableHead
        pagination
        paginationPerPage={30}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        subHeader
        progressPending={gridState.loading}
        progressComponent={<div><LoadingDiv><ReactLoading
          type={"bars"}
          color={"#91c241"}
          height={"10%"}
          width={"10%"}
        /></LoadingDiv></div>}
        //highlightOnHover
        //pointerOnHover

        conditionalRowStyles={conditionalRowStyles}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: true,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />


    </>
  );
};

export default RTDashboard;
